import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { filtering, sorting } from '../features/postFilter/filterPosts';

const Sidebar = () => {

  const dispatch =useDispatch()




  const { posts,savedPosts, isLoading, isError, error } = useSelector(
      (state) => state.posts
  );
  const { filter,sort} = useSelector(
      (state) => state.filterPosts
  );
console.log('filter', filter)

  return (
    <> <aside>
    <div className="sidebar-items">
      <div className="sidebar-content">
        <h4>Sort</h4>
        <select value={sort}  onChange={(e)=>{
              dispatch(sorting(e.target.value))
            }} name="sort" id="lws-sort" className="w-full max-w-[150px] border-2 rounded-md text-gray-500">
          <option >Default</option>
          <option value="newest">Newest</option>
          <option value="most_liked">Most Liked</option>
        </select>
      </div>
      <div className="sidebar-content">
        <h4>Filter</h4>
        <div className="radio-group">
          {/* handle filter on button click */}
          <div>
            <input checked={filter=="All"}   onChange={()=>{
              dispatch(filtering('All'))
            }} type="radio" name="filter" id="lws-all" defaultChecked className="radio" />
            <label htmlFor="lws-all">All</label>
          </div>
          <div>
            <input checked={filter=="Saved"} onChange={()=>{
              dispatch(filtering('Saved'))
            }} type="radio" name="filter" id="lws-saved" className="radio" />
            <label htmlFor="lws-saved">Saved</label>
          </div>
        </div>
      </div>
    </div>
  </aside></>
  )
}

export default Sidebar